import {
  applyMiddleware,
  combineReducers,
  compose,
  configureStore,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import user_auth_slice from "./slices/user_auth_slice";

let reducers = combineReducers({
  userAuth: user_auth_slice,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = configureStore(
  { reducer: reducers },
  composeEnhancers(applyMiddleware(thunk))
);
export default store;
